// Enums are dictionary of names versus numbers. This is so they work in the same way as C# enums (and other languages) which allow multiple names to have the same number.

let australianStateEnum = {
    'WesternAustralia': 0,
    'NewSouthWales': 1,
    'Victoria': 2,
    'Queensland': 3,
    'SouthAustralia': 4,
    'Tasmania': 5,
    'NorthernTerritory': 6,
    'AustralianCapitalTerritory': 7
};

export default australianStateEnum;
